import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';
import { InputTextarea } from 'primereact/inputtextarea';

import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import FileService from '../service/FileService';
import { RadioButton } from 'primereact/radiobutton';

const CustomAddArtworks = (props) => {
    console.log("CustomAddArtworks props: ", props);

    const toast = useRef(null);

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [selectedAddType, setSelectedAddType] = useState();
    const [edition, setEdition] = useState("");
    const [artworkName, setArtworkName] = useState("");
    const [material, setMaterial] = useState();
    const [artWidth, setArtWidth] = useState("");
    const [artHeight, setArtHeight] = useState("");
    const [measureUnit, setMeasureUnit] = useState("");
    const [artType, setArtType] = useState("");


    const [file, setFile] = useState();
    const [selectedYear, setSelectedYear] = useState();
    const yearItems = Array.from({ length: utils.currentYear }).map((_, i) => ({ label: `${utils.currentYear - i}`, value: utils.currentYear - i }));
    const measureUnits = [
        "centimeter",
        "pixel"
    ]




    let { usermail, verificationToken, action } = useParams();

    useEffect(() => {
        console.log("CustomAddArtworks props props?.artwork?.artworkName: ", props?.artwork?.artworkName);

        setArtworkName(props?.artwork?.name);
        setEdition(props?.artwork?.descr);
        setMaterial(props?.artwork?.material);
        setArtWidth(props?.artwork?.artWidth);
        setArtHeight(props?.artwork?.artHeight);
        setMeasureUnit(props?.artwork?.measureUnit);
        setArtType(props?.artwork?.artType);
        setSelectedYear(props?.artwork?.artYear);
        //  setFile(FileService.inquireFilePath(props?.artwork?.file)) ;

    }, []);




    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }



    useEffect(() => {

    }, []);




    const onFileSelect = (props) => {
        setFile(props.files[0])
        console.log("onFileSelect", props);
    };





    const checkButtonStatus = () => {

        /*  console.log("checkButtonStatus", file, artworkName, edition, artworkName?.length > 0, edition?.length > 0)
          console.log("artwork", (artworkName && edition && artworkName?.length > 0 && edition?.length > 0 && file?.objectURL?.length))
          if (artworkName && edition && artworkName?.length > 0 && edition?.length > 0 && file?.objectURL?.length > 0) {
              return false;
          }
  
          return true;*/

    }

    const onClear = () => {
        setArtworkName("");
        setEdition("")
        setFile(null);

    }
    const onAddArtWork = async () => {


        console.log("onAddArtWork");

        if (!artworkName || artworkName?.length == 0) {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("error_artwork_name"), life: 5000 });
            return null;
        }
        if (!edition || edition?.length == 0) {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("error_artwork_descr"), life: 5000 });
            return null;
        }


        if (artworkName && edition && artworkName?.length > 0 && edition?.length > 0) {
            setDisplayLoadingDialog(true);
            if (props?.artwork?.id) {
                const apiParams = {
                    name: artworkName, descr: edition, fileType: Constants.fileTypes.artwork,
                    material, artWidth, artHeight, measureUnit, artType, artYear: selectedYear, upploadFlag: true,
                    id: props?.artwork?.id
                };
                props.artwork.name = artworkName;
                props.artwork.descr = edition;
                props.artwork.material = material;
                props.artwork.artWidth = artWidth;
                props.artwork.artHeight = artHeight;
                props.artwork.measureUnit = measureUnit;
                props.artwork.artType = artType;
                props.artwork.artYear = selectedYear;

                uploadFile(apiParams);
            } else {
                if (!file) {
                    toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("error_artwork_file"), life: 5000 });
                    return null;
                }

                const reader = new FileReader();
                let blob = await fetch(file.objectURL).then(r => r.blob()); //blob:url
                reader.readAsDataURL(blob);
                reader.onloadend = function () {

                    const base64data = reader.result;

                    const apiParams = {
                        file: base64data, fileName: file.name, name: artworkName, descr: edition, fileType: Constants.fileTypes.artwork,
                        material, artWidth, artHeight, measureUnit, artType, artYear: selectedYear, upploadFlag: true,
                        id: props?.artwork?.id
                    };
                    uploadFile(apiParams);


                }

            }



        } else {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_detail"), life: 5000 });

        }


    }

    const uploadFile = (apiParams) => {
        FileService.uploadImage(apiParams).then(

            (response) => {

                console.log("onAddArtWork", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onAddArtWork", response);
                    console.log("onAddArtWork props", props);


                    setDisplayLoadingDialog(false);
                    onClear();

                    props?.setDialogVisible(false);
                    if (props?.loadUserArtworks) {
                        console.log("*********************-----")
                        props?.loadUserArtworks();

                    }


                    let _detail = t('add_artwork_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }





    const onYearItemChange = (e) => {
        setSelectedYear(e.value);
    }


    const chooseOptions = { icon: 'fas fa-cloud-arrow-up file-upload-icon p-button-header', iconOnly: true, padding: 0 };

    const renderArtworkPanel = () => {

        return (
            <div className="col-12 md:col-12 flex justify-content-center " >
                <div className=" register-content  w-12   p-3 ">
                    <div className="flex flex-row">
                        <div className="flex align-items-center align-content-center justify-content-center col-12 md:col-6 file-upload-content"
                            style={{
                                backgroundImage: `url(${file?.objectURL ? file?.objectURL : FileService.inquireFilePath(props?.artwork?.file)})`,
                            }}>
                            {!file &&
                                <FileUpload mode="basic" name="demo[]"
                                    accept="image/*" maxFileSize={10000000}
                                    onSelect={onFileSelect}
                                    customUpload
                                    chooseOptions={chooseOptions}


                                />
                            }
                        </div>
                        <div className="col-12 md:col-6" >
                            <div className="flex flex-column">
                                <div className="col-12 md:col-12" style={{
                                    wordWrap: 'break-word',
                                    paddingBottom: 5,
                                }}>
                                    {t('artwork_info_header')}
                                </div>
                                <div className="col-12 md:col-12  ">
                                    <InputText id="artistname" value={AuthService.getFullName()} disabled
                                        className="inputtext_raunded p-inputtext " type="text" ></InputText>
                                </div>
                                <div className="col-12 md:col-12  ">
                                    <InputText id="artworkname" value={artworkName} onChange={(e) => setArtworkName(e.target.value)} autoComplete="off"
                                        className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_artwork_name')}
                                        maxLength={40}
                                    ></InputText>
                                </div>
                                <div className="col-12 md:col-12  ">
                                    <InputTextarea id="edition" value={edition} onChange={(e) => setEdition(e.target.value)} autoComplete="off"
                                        rows={3} maxLength={140}
                                        className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_artwork_edition')}></InputTextarea>
                                </div>

                                <div className="flex flex-row justify-content-between align-items-center col-12 md:col-12  ">

                                    <Dropdown className='dropdown_raunded' value={selectedYear} options={yearItems} onChange={onYearItemChange} virtualScrollerOptions={{ itemSize: 25 }} placeholder={t('global_artwork_createdate')} />

                                    <div className="flex flex-row justify-content-between align-items-center  ">
                                        <RadioButton inputId="physically" name="artType" value="physically" onChange={() => setArtType('physically')} checked={artType === 'physically'} />
                                        <label htmlFor="physically"> {t('global_artwork_physically')}</label>
                                    </div>
                                    <div className="flex flex-row justify-content-between align-items-center ">

                                        <RadioButton inputId="digital" name="artType" value="digital" onChange={() => setArtType('digital')} checked={artType === 'digital'} />
                                        <label htmlFor="digital"> {t('global_artwork_digital')}</label>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )

    }

    const measureUnitTemplate = (option) => {
        return (
            <div >
                {t('global_artwork_' + option)}

            </div>
        );
    };
    const selectedMeasureUnitTemplate = (option, props) => {
        if (option) {
            return (
                <div >
                    {t('global_artwork_' + option)}
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };
    const renderArtworkOptionsPanel = () => {

        return (
            <div className="col-12 md:col-12 flex justify-content-center " >
                <div className=" register-content  w-12   p-3 ">
                    <div className="col-12 md:col-12" style={{
                        wordWrap: 'break-word',
                        marginBottom: 5,
                    }}>
                        {t('artwork_info_options_header')}
                    </div>
                    <div className="flex flex-row align-items-center mb-2">


                        <InputText id="artWidth" value={artWidth} onChange={(e) => setArtWidth(e.target.value)} autoComplete="off"
                            style={{ width: '75px' }}
                            className="inputtext_raunded p-inputtext mr-2" type="text" placeholder={t('global_artwork_width')}></InputText>

                        X
                        <InputText id="artHeight" value={artHeight} onChange={(e) => setArtHeight(e.target.value)} autoComplete="off"
                            style={{ width: '75px' }}
                            className="inputtext_raunded p-inputtext mr-2 ml-2" type="text" placeholder={t('global_artwork_height')}></InputText>



                        <Dropdown className='dropdown_raunded mr-2' value={measureUnit} options={measureUnits} itemTemplate={measureUnitTemplate} valueTemplate={selectedMeasureUnitTemplate}
                            onChange={(e) => setMeasureUnit(e.value)} placeholder={t('global_artwork_measureunits')} />


                        <InputText id="material" value={material} onChange={(e) => setMaterial(e.target.value)} autoComplete="off"
                            maxLength={20}
                            className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_artwork_material')}></InputText>




                    </div>
                </div>
            </div>

        )

    }

    /* IMAGE UPLOAD*/
    const renderButton = () => {


        return (
            <div className="col-12 md:col-12 flex justify-content-center " >
                <div className=" flex justify-content-between p-1 w-12 pr-3 pl-3" >
                    <div className=" w-fit ">
                        <Button label={t("global_btn_clear")} className="p-button-rounded mr-2 mb-2"
                            onClick={() => onClear()}

                        />

                    </div> <div className=" w-fit ">

                        <Button label={props?.artwork?.id ? t("global_btn_update") : t("global_button_addartwork")} className="p-button-rounded mr-2 mb-2" disabled={checkButtonStatus()}
                            onClick={() => onAddArtWork()}

                        />
                    </div>

                </div>
            </div>
        )


    }
    return (
        <div className="grid p-fluid flex justify-content-center p-2" style={{ maxWidth: 650 }}>
            <Toast ref={toast} />
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {renderArtworkPanel()}

            {renderArtworkOptionsPanel()}
            {renderButton()}


        </div>
    )
}

export default CustomAddArtworks;